import { createFileRoute } from '@tanstack/react-router'
import FolderRestrictionPopup from '../../../../../containers/ManageUsers/components/FolderRestrictionPopup'


export const Route = createFileRoute(
  '/_authenticated/userManagement/folderRestriction/$userId/'
)({
  component: FolderRestrictionPopup
})
